<script>
    import Button from 'views/components/button/Button.svelte'
    import Checkbox from 'views/components/checkbox/Checkbox.svelte'
    import Icon from 'views/components/icon/Icon.svelte'
    import SelfAssessmentUtil from 'views/pages/activities/show/types/selfAssessment/SelfAssessmentUtil';

    let {
        selectedLearningGoals = $bindable(),
        onStartCallback,
        onReviewCallback,
        activityModel
    } = $props()

    const learningGoals = $derived(activityModel.get('self_assessment').learning_goals)
    const hasAnyResponses = $derived(ACL.checkRole(ACL.roles.STUDENT) && activityModel.responses.length > 0)
    // 'begin' | 'review' | null
    let submittingAction = $state(null)

    function onSubmit(event) {
        event.preventDefault()

        if (submittingAction) {
            return
        }

        selectedLearningGoals = new FormData(event.target).getAll('learningGoal').map(id => parseInt(id, 10))

        if (!selectedLearningGoals.length) {
            Backbone.View.layout.openStatus(
                window.i18n.gettext('Select at least one learning goal.')
            )
            return
        }

        submittingAction = 'begin'
        onStartCallback()
    }

    function onClickReview() {
        submittingAction = 'review'
        onReviewCallback()
    }
</script>

<div class="container">
    <form class="form" onsubmit={onSubmit}>
        <h2>{window.i18n.gettext('Select learning goals to practice')}</h2>
        <p>{window.i18n.gettext('Test your knowledge. When you\'re finished, you\'ll see which learning goals you\'ve achieved.')}</p>
        <div class="learning-goals">
            {#each learningGoals as learningGoal (learningGoal.id)}
                {const isAchieved = SelfAssessmentUtil.isLearningGoalAchieved(learningGoal.id, activityModel)}
                <div class="learning-goal">
                    <Checkbox
                        value={learningGoal.id}
                        label={learningGoal.name}
                        isChecked={!isAchieved || ACL.checkRole(ACL.roles.TEACHER)}
                        parentGroup="learningGoal"
                        isOnDarkBackground={true}
                    >
                    </Checkbox>

                    {#if ACL.checkRole(ACL.roles.STUDENT)}
                        <div class="status">
                            {#if isAchieved}
                                <span class="achieved"><Icon name="checkmark-circle-fill"></Icon></span>
                                {window.i18n.gettext('Achieved')}
                            {:else}
                                <span class="not-achieved-yet"><Icon name="checkmark-circle-fill"></Icon></span>
                                {window.i18n.gettext('Not achieved yet')}
                            {/if}
                        </div>
                    {/if}
                </div>
            {/each}
        </div>
        <div class="button">
            <Button
                label={window.i18n.gettext('Begin')}
                iconRight="arrow-right"
                theme="secondary"
                size="medium"
                type="submit"
                disabled={submittingAction !== null}
                hasSpinner={submittingAction === 'begin'}>
            </Button>

            {#if hasAnyResponses}
                <Button
                    label={window.i18n.gettext('Review')}
                    iconRight="lightbulb"
                    theme="secondary"
                    size="medium"
                    type="button"
                    callback={onClickReview}
                    disabled={submittingAction !== null}
                    hasSpinner={submittingAction === 'review'}>
                </Button>
            {/if}
        </div>
    </form>
</div>

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
.container {
  position: absolute;
  inset: 0;
  display: flex;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  background-color: hsl(205, 60%, 44%);
  color: #fff;
}
.container .form {
  margin: auto;
  min-width: min(100%, 520px);
  max-width: 620px;
}
.container .form h2 {
  margin: 0;
}
.container .form p {
  font-size: 16px;
  margin: 12px 0 0 0;
}
.container .form .learning-goals {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 20px;
  padding: 16px;
  border-radius: 16px;
  background-color: rgba(0, 0, 0, 0.1);
}
.container .form .learning-goals .learning-goal {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.container .form .learning-goals .learning-goal .status {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  padding: 6px 12px 6px 6px;
  border-radius: 16px;
  background-color: rgba(0, 0, 0, 0.5);
}
.container .form .learning-goals .learning-goal .status .not-achieved-yet {
  color: rgba(255, 255, 255, 0.5);
}
.container .form .learning-goals .learning-goal .status .achieved {
  color: #3fd17d;
}
.container .form .learning-goals .learning-goal .status :global(svg) {
  fill: currentColor;
  display: flex;
  width: 20px;
  height: 20px;
}
.container .form .button {
  display: flex;
  margin-top: 20px;
  justify-content: space-between;
  flex-direction: row-reverse;
}</style>
